var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sub-title-box', _vm.theme]},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"square"})]),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }